<template>
  <form ref="form" @submit="handleRegister" novalidate>
    <div class="modal-dialog" style="min-width: 400px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Create Account</h5>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" v-if="errorMessage">
            {{ errorMessage }}
          </div>
          <div class="alert alert-danger" v-if="errorDetails">
            <ul id="error-details">
              <li v-for="detail in errorDetails.split(',')" :key="detail">
                {{ detail }}
              </li>
            </ul>
          </div>
          <div class="form-group mb-2">
            <div class="row">
              <div class="col">
                <label for="firstName" class="form-label"
                  >Your Name: <alzata-required-indicator
                /></label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  placeholder="First"
                  v-model="firstName"
                  ref="firstName"
                  required
                  :disabled="busy"
                  data-lpignore="true"
                />
              </div>
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Last"
                  v-model="lastName"
                  ref="lastName"
                  required
                  :disabled="busy"
                  data-lpignore="true"
                />
              </div>
            </div>
          </div>
          <div class="form-group mb-2">
            <div class="row">
              <div class="col">
                <label for="email" class="form-label"
                  >Email Address: <alzata-required-indicator
                /></label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  v-model="email"
                  required
                  :disabled="busy"
                  data-lpignore="true"
                />
              </div>
            </div>
          </div>
          <!-- <div class="form-group mb-2">
            <div class="row">
              <div class="col">
                <label for="phone" class="form-label"
                  >Phone Number: <alzata-required-indicator
                /></label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  v-model="phoneNumber"
                  required
                  :disabled="busy"
                  data-lpignore="true"
                />
              </div>
            </div>
          </div> -->
          <!-- <div class="form-group mb-2">
            <div class="row">
              <div class="col">
                <label for="phone" class="form-label"
                  >Username: <alzata-required-indicator
                /></label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  v-model="username"
                  required
                  :disabled="busy"
                  data-lpignore="true"
                />
              </div>
            </div>
          </div> -->
          <div class="form-group mb-2">
            <div class="row">
              <div class="col">
                <label for="phone" class="form-label"
                  >Password: <alzata-required-indicator
                /></label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="input-group mb-3">
                  <input
                    v-bind:type="[showPassword ? 'text' : 'password']"
                    class="form-control"
                    v-model="password"
                    required
                    :disabled="busy"
                    data-lpignore="true"
                  />
                  <span class="input-group-text" @click="passwordToggle">
                    <alzata-icon
                      :icon="showPassword ? 'far/eye' : 'far/eye-slash'"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-primary text-center"
              :disabled="busy"
            >
              {{ busy ? "Creating Account..." : "Create Account" }}
            </button>
          </div>
        </div>
        <div
          class="modal-footer bg-light small"
          style="justify-content: space-between"
        >
          <router-link
            v-if="$router.hasRoute('alzata:account/login')"
            :to="{ name: 'alzata:account/login' }"
            >Sign In</router-link
          >
          <router-link
            v-if="$router.hasRoute('alzata:account/recover')"
            :to="{ name: 'alzata:account/recover' }"
            >Forgot Password</router-link
          >
        </div>
      </div>
    </div>
  </form>
</template>

<script>
function isValidEmail(email) {
  // use a regular expression to test if the email address is in the correct format
  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regex.test(email);
}

export default {
  name: "AlzataCreateAccount",
  data: () => ({
    name: {
      first: "",
      last: "",
    },
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    //username: "",
    password: "",
    passwordErrors: null,
    usernameErrors: null,
    errorMessage: null,
    errorDetails: null,
    showPassword: false,
    busy: false,
    formWasValidated: false,
  }),
  mounted() {
    this.$refs.firstName.focus();
  },
  methods: {
    async handleRegister(evt) {
      evt.preventDefault();
      this.errorMessage = null;
      this.errorDetails = null;
      this.busy = true;
      try {
        if (!isValidEmail(this.email)) {
          this.errorMessage = "Please enter a valid email address.";
          window.setTimeout(() => this.$refs.email.focus(), 0);
          return;
        }

        const result = await this.apiClient.register(
          this.firstName,
          this.lastName,
          this.email,
          //this.phoneNumber,
          this.email,
          this.password
        );
        if (result.id) {
          window.setTimeout(() => this.$router.replace("/account/login"), 0);
        } else {
          this.errorMessage = result.errorMessage;
          this.errorDetails = result.displayMessage;
          //window.setTimeout(() => this.$refs.firstName.focus(), 0);
        }
      } finally {
        this.busy = false;
      }
    },
    passwordToggle() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
